import { customerApi } from "../../utils/apiConfig";

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

/*
========================================
PLAN
========================================
*/

export const hygienePlanInsert = (payload) => {
  return customerApi.post("/createHygienePlan", payload, authHeader());
};

export const hygienePlanUpdate = (payload) => {
  return customerApi.post("/updateHygienePlan", payload, authHeader());
};

export const hygienePlanDelete = (payload) => {
  return customerApi.post("/deleteHygienePlan", payload, authHeader());
};

export const hygienePlanList = () => {
  return customerApi.get("/getHygienePlans", authHeader());
};

/*
========================================
ITEM
========================================
*/

export const hygieneItemAdd = (payload) => {
  return customerApi.post("/addHygieneItem", payload, authHeader());
};

export const hygieneItemUpdate = (payload) => {
  return customerApi.post("/updateHygieneItem", payload, authHeader());
};

export const hygieneItemDelete = (payload) => {
  return customerApi.post("/deleteHygieneItem", payload, authHeader());
};

/*
========================================
OPERATION
========================================
*/

// tek checkbox
export const hygieneItemCheck = (payload) => {
  return customerApi.post("/checkHygieneItem", payload, authHeader());
};

// bulk checkbox
export const hygieneBulkCheck = (payload) => {
  return customerApi.post("/bulkCheckHygieneItems", payload, authHeader());
};

// detail (plan + item + check)
export const hygienePlanDetail = (planId, month) => {
  return customerApi.get(
    `/getHygienePlanDetail/${planId}/${month}`,
    authHeader()
  );
};

// complete
export const hygienePlanComplete = (payload) => {
  return customerApi.post("/completeHygienePlanMonth", payload, authHeader());
};

// reset
export const hygienePlanReset = (payload) => {
  return customerApi.post("/resetHygienePlanMonth", payload, authHeader());
};



export const getPersonelForEquipmentPlan = () => {
  return customerApi.get("/getPersonelForHygiene", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

